import { GETNOTES_SUCCESS, GETNOTES_FAIL } from '../actionTypes';

const initialState = {
    user: null
};

const getNotesReducer = (state = initialState, action) => {
    switch (action.type) {
        case GETNOTES_SUCCESS:
            return {
                ...state,
                isLoggedIn: true,
                user: action.payload.user,
            };
        case GETNOTES_FAIL:
            return {
                ...state,
                isLoggedIn: false,
                user: null,
            };
        default:
            break;
    }

    return state;
};

export default getNotesReducer;
